export type CameraMode = 'normal' | 'overhead' | 'close' | 'wide' | 'follow' | 'chase';

// Keep `wide` in the persisted CameraMode union so old local settings can be
// migrated safely, but do not expose the room-heavy legacy framing in the
// normal camera cycle. A dedicated cinematic mode can return as a supported
// preference once its cabinet-focused composition is intentionally designed.
export const CAMERA_MODES: Array<{ id: CameraMode; label: string; shortLabel: string }> = [
  { id: 'normal', label: 'Player cabinet perspective', shortLabel: 'Player' },
  { id: 'overhead', label: 'Straight overhead playfield', shortLabel: 'Above' },
  { id: 'close', label: 'Close playfield action', shortLabel: 'Close' },
  { id: 'follow', label: 'Follow the ball', shortLabel: 'Follow' },
  { id: 'chase', label: 'Over-the-shoulder ball chase', shortLabel: 'Ball Cam' },
];

export function nextCameraMode(mode: CameraMode): CameraMode {
  const index = CAMERA_MODES.findIndex((candidate) => candidate.id === mode);
  return CAMERA_MODES[(index + 1 + CAMERA_MODES.length) % CAMERA_MODES.length]!.id;
}

export function cameraModeLabel(mode: CameraMode): string {
  if (mode === 'wide') return 'Player';
  return CAMERA_MODES.find((candidate) => candidate.id === mode)?.shortLabel ?? 'Player';
}
